import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./sse.service";
import * as i2 from "@angular/common/http";
var JourgemachineService = /** @class */ (function () {
    function JourgemachineService(_zone, _sseService, http) {
        this._zone = _zone;
        this._sseService = _sseService;
        this.http = http;
    }
    JourgemachineService.prototype.getServerSentEvent = function (url) {
        var _this = this;
        return Observable.create(function (observer) {
            var es = _this._sseService.getEventSource(url);
            es.onmessage = function (event) {
                _this._zone.run(function () { return observer.next(event); });
            };
            es.onerror = function (error) {
                observer.error(error);
            };
        });
    };
    JourgemachineService.prototype.listenForUpdates = function () {
        return this.http.get("readMachineData");
    };
    JourgemachineService.prototype.getMachineData = function (data) {
        return this.http.post("getLastData", data);
    };
    JourgemachineService.prototype.getDailyGeorgMachineDuration = function () {
        return this.http.get("getDailyGeorgMachineDuration");
    };
    JourgemachineService.prototype.getGeorgMachineReport = function (data) {
        return this.http.post("getGeorgMachineReport", data);
    };
    JourgemachineService.prototype.getGeorgMachineWorkingReport = function (data) {
        return this.http.post("getGeorgMachineWorkingReport", data);
    };
    JourgemachineService.prototype.getDeviceIDS = function () {
        return this.http.get("getDeviceIds");
    };
    JourgemachineService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function JourgemachineService_Factory() { return new JourgemachineService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.SseService), i0.ɵɵinject(i2.HttpClient)); }, token: JourgemachineService, providedIn: "root" });
    return JourgemachineService;
}());
export { JourgemachineService };
